const parseBoolean = (value, defaultValue = false) => {
    if (typeof value !== 'string') {
        return defaultValue;
    }

    const normalized = value.trim().toLowerCase();
    if (normalized === 'true') return true;
    if (normalized === 'false') return false;

    return defaultValue;
};

const normalizeMode = (value) => {
    if (typeof value !== 'string') {
        return 'remote-backend';
    }

    const normalized = value.trim().toLowerCase();
    if (normalized === 'local-dev' || normalized === 'remote-backend') {
        return normalized;
    }

    return 'remote-backend';
};

const normalizeIceTransportPolicy = (value) => {
    if (typeof value !== 'string') {
        return 'relay';
    }

    const normalized = value.trim().toLowerCase();
    if (normalized === 'all' || normalized === 'relay') {
        return normalized;
    }

    return 'relay';
};

const trimOrDefault = (value, fallback = '') => {
    if (typeof value !== 'string') {
        return fallback;
    }

    const nextValue = value.trim();
    return nextValue || fallback;
};

const normalizePath = (value, fallback) => {
    const nextValue = typeof value === 'string' && value.trim() ? value.trim() : fallback;
    return nextValue.startsWith('/') ? nextValue : `/${nextValue}`;
};

const parseIceServers = (value) => {
    if (typeof value !== 'string' || !value.trim()) {
        return null;
    }

    try {
        const parsed = JSON.parse(value);
        return Array.isArray(parsed) ? parsed : null;
    } catch {
        return null;
    }
};

const defaultTurnFallbackIceServers = [{ urls: 'stun:stun.l.google.com:19302' }];

export const callConfig = Object.freeze({
    featureEnabled: parseBoolean(process.env.REACT_APP_CALL_FEATURE_ENABLED, false),
    mode: normalizeMode(process.env.REACT_APP_CALL_MODE),
    signalingWsUrl: process.env.REACT_APP_SIGNALING_WS_URL || '',
    devAuthBaseUrl: trimOrDefault(
        process.env.REACT_APP_CALL_DEV_AUTH_BASE_URL,
        'http://localhost:42795'
    ),
    devUserId: trimOrDefault(process.env.REACT_APP_CALL_DEV_USER_ID, 'user-a'),
    deviceIdStorageKey: trimOrDefault(
        process.env.REACT_APP_CALL_DEVICE_ID_STORAGE_KEY,
        'call-device-id'
    ),
    signalingTokenPath: normalizePath(
        process.env.REACT_APP_CALL_SIGNALING_TOKEN_PATH,
        '/call/token/signaling'
    ),
    turnTokenPath: normalizePath(
        process.env.REACT_APP_CALL_TURN_TOKEN_PATH,
        '/call/token/turn'
    ),
    callableUsersPath: normalizePath(
        process.env.REACT_APP_CALL_CALLABLE_USERS_PATH,
        '/calls/users'
    ),
    callableUsersFallbackEnabled: parseBoolean(
        process.env.REACT_APP_CALL_CALLABLE_USERS_FALLBACK_ENABLED,
        process.env.NODE_ENV !== 'production'
    ),
    presencePingEnabled: parseBoolean(
        process.env.REACT_APP_CALL_PRESENCE_PING_ENABLED,
        true
    ),
    presencePingIntervalMs: Number.parseInt(
        process.env.REACT_APP_CALL_PRESENCE_PING_INTERVAL_MS || '30000',
        10
    ),
    presencePingBackgroundIntervalMs: Number.parseInt(
        process.env.REACT_APP_CALL_PRESENCE_PING_BG_INTERVAL_MS || '120000',
        10
    ),
    turnFallbackEnabled: parseBoolean(
        process.env.REACT_APP_CALL_TURN_FALLBACK_ENABLED,
        process.env.NODE_ENV !== 'production'
    ),
    turnFallbackIceServers:
        parseIceServers(process.env.REACT_APP_CALL_TURN_FALLBACK_ICE_SERVERS) ||
        defaultTurnFallbackIceServers,
    iceTransportPolicy: normalizeIceTransportPolicy(
        process.env.REACT_APP_CALL_ICE_TRANSPORT_POLICY
    ),
    resumeEnabled: parseBoolean(process.env.REACT_APP_CALL_RESUME_ENABLED, true)
});
